
import React, { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import AccessRequestPopup from "./AccessRequestPopup";
import logoGif from "../Assets/logo - Colored Background@2x.png";

const AccessGateWrapper = ({
  user,
  fetchAccessStatus,
  accessStatus,
  setAccessStatus,
  showAccessPopup,
  setShowAccessPopup,
  children,
}) => {
  const { profile } = useAuth(); // ✅ correct source of orgId
  const organizationId = profile?.orgId;
  const regionCode = sessionStorage.getItem("userRegion") || "AP";
  const isConsentLink = window.location.pathname.startsWith("/consent/");

  // ✅ MAIN FIX: Call API ONLY when profile.orgId is ready
  // useEffect(() => {
  //   if (!user || !organizationId) {
  //     console.log("⏳ Waiting for profile.orgId...");
  //     return;
  //   }

  //   console.log("🚀 Calling API with profile.orgId:", organizationId);

  //   fetchAccessStatus(organizationId,regionCode);

  // }, [user, organizationId]);

 useEffect(() => {
  if (isConsentLink) return;
  if (user && organizationId) {
    const regionCode = sessionStorage.getItem("userRegion") || "AP";
    fetchAccessStatus(organizationId, regionCode);
  }
}, [user, organizationId, fetchAccessStatus, isConsentLink]);

  // ✅ DEBUG (safe and correct)
  // useEffect(() => {
  //   if (profile) {
  //     console.log("👤 PROFILE OBJECT:", profile);
  //     console.log("✅ profile.orgId:", profile?.orgId);

  //     // for manual testing in console
  //     window.orgIdDebug = profile?.orgId;
  //   }
  // }, [profile]);

  const isApproved = accessStatus === "approved";
  if (isConsentLink) return <>{children}</>;

  return (
   <>
      {user && !isApproved && !showAccessPopup && (
        <div className="loading-screen">
          <img src={logoGif} alt="Loading..." className="logo-animation" />
        </div>
      )}

      
{user &&
  !isApproved &&
  showAccessPopup &&
  organizationId && (
    <AccessRequestPopup
      organizationId={organizationId}
      accessStatus={accessStatus}          // ✅ Pass DynamoDB status
      onRequestAccess={async () => {
        const regionCode = sessionStorage.getItem("userRegion") || "AP";
        const res = await fetch(
          "https://tzyawyhgbb.execute-api.ap-southeast-2.amazonaws.com/prod/api/prod/request-access",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              orgId: organizationId,
              userEmail: user?.email,
              userName: user?.name || user?.given_name,
              regionCode,
            }),
          }
        );
        if (!res.ok) throw new Error("Request failed");
        const data = await res.json();
        setAccessStatus(data.status || "pending");  // ✅ updates from DynamoDB response
      }}
      onRefresh={async () => {
        const regionCode = sessionStorage.getItem("userRegion") || "AP";
        await fetchAccessStatus(organizationId, regionCode);
      }}
    />
  )}

      {/* ✅ RENDER APP */}
      
      {(!user || isApproved) && children}
    </>
  );
};

export default AccessGateWrapper;